import React from 'react';
import { Box, Typography } from '@mui/material';
import InfoCardDossier from '../../InfoCardDossier/InfoCardDossier';
import { PeoplePreview } from '../../../liste';
import { CommercialCardProps } from './types';

const CommercialCard: React.FunctionComponent<CommercialCardProps> = function ({
    commercialNom,
    commercialPrenom,
    commercialUserIdentifier,
    infoCardSx,
    textStyle,
    palette,
    userInterne,
    onClickUser,
}) {
    const hasAssignedCommercial = Boolean(commercialPrenom && commercialNom);

    const renderContent = () => {
        if (hasAssignedCommercial) {
            return (
                <>
                    <PeoplePreview
                        firstName={commercialPrenom}
                        lastName={commercialNom}
                        userIdentifier={commercialUserIdentifier}
                        sx={{ margin: '0 10px 0 0' }}
                        onClick={onClickUser}
                    />
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography
                            sx={textStyle}
                            component="span"
                        >
                            {`${commercialPrenom} ${commercialNom}`}
                        </Typography>
                    </Box>
                </>
            );
        }

        return userInterne ? (
            <Typography
                sx={{
                    ...textStyle,
                    fontStyle: 'italic',
                    color: palette.error.main,
                }}
                component="span"
            >
                Aucun commercial disponible
            </Typography>
        ) : null;
    };

    return (
        <InfoCardDossier
            label="Commercial"
            sx={infoCardSx}
        >
            {renderContent()}
        </InfoCardDossier>
    );
};

export default CommercialCard;
